import Vue from 'vue'

export default Vue.extend({
  template: `
    <div class="grid grid-rows-2 justify-center items-center" style="position: absolute; top: 50%; min-height: 1000px;">
      <div class="w-full flex justify-center items-center mb-3" style="min-height: 500px;">
        <div class="sk-chase">
          <div class="sk-chase-dot"></div>
          <div class="sk-chase-dot"></div>
          <div class="sk-chase-dot"></div>
          <div class="sk-chase-dot"></div>
          <div class="sk-chase-dot"></div>
          <div class="sk-chase-dot"></div>
        </div>
      </div>
      <p class="text-xl text-gray-700">{{ params.loadingMessage }}</p>
    </div>
    `,
  data () {
    return {}
  },
  beforeMount () {},
  mounted () {},
  methods: {}
})
